import { createNode } from '@glueapp/graph-types';
import { isShapeValue } from '@glueapp/graph-types';

export const ParseJSON = createNode({
    id: 'Parse JSON',
    name: 'Parse JSON',
    description: 'Create an Convert to string',
    aiDescription: [
        'Parses a JSON string into a typed value. Setup steps:',
        '1. Set "Result Shape" to define the expected output type:',
        '   glue set-value <id> "Result Shape" \'{"isShapeValue":true,"type":{"kind":"object","properties":{"name":{"kind":"string"},"age":{"kind":"number"}},"restriction":"open"}}\'',
        '   - The "Result" output port is ONLY visible when "Result Shape" has a value. Without it, there are no output ports.',
        '   - The type of the "Result" output port matches exactly what you set in "Result Shape".',
        '2. Connect or set the "Input" port (string) — this is the raw JSON string to parse.',
        '3. Use glue shape <id> after setting Result Shape to verify the output port appeared with the correct type.',
    ].join('\n'),
    category: 'JSON',
    color: '#bf7ee2',
    integration: undefined,
    computeShape: input => {
        const shapePortValue = input.portValues['Result Shape'];
        if (isShapeValue(shapePortValue)) {
            return { inPorts: input.nodeInPorts, outPorts: [{ name: 'Result', type: shapePortValue.type }] };
        } else {
            return { inPorts: input.nodeInPorts, outPorts: [] };
        }
    },
    inPorts: {
        'Result Shape': {
            kind: 'shape',
            restriction: undefined,
        },
        Input: { kind: 'string' },
    },
    outPorts: {
        Result: { kind: 'string' },
    },
    execute: function (input) {
        const inputString = input.inPorts.Input;
        const parsedInput = JSON.parse(inputString);
        return { output: { Result: parsedInput } };
    },
});
